import { render, staticRenderFns } from "./side_drawer.vue?vue&type=template&id=a10350de&scoped=true&lang=pug"
import script from "./side_drawer.vue?vue&type=script&lang=js"
export * from "./side_drawer.vue?vue&type=script&lang=js"
import style0 from "./side_drawer.vue?vue&type=style&index=0&id=a10350de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a10350de",
  null
  
)

export default component.exports